<template>
  <div>
    <el-dialog
      title="选择门店"
      :visible.sync="doorDialogVisible"
      width="50%"
      center
    >
      <div style="margin: 10px 0 20px">
        <el-input
          placeholder="请输入门店名"
          v-model="searchKey">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
          <el-button slot="append" @click="getDoorList">搜索</el-button>
        </el-input>
      </div>
      <div class="checkboxList doorList" v-loading="loading">
        <el-checkbox-group v-model="checkList">
          <el-checkbox v-for="(door, i) in doorList" :key="i" :label="door.posId">{{ door.doorName }}</el-checkbox>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitDoor">选择</el-button>
        <el-button type="info" @click="doorDialogVisible = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'pickDoor',
  props: {
    value: String,
    filterForm: {
      cityNo: Array,
      clusterGroup: Array,
      clusterName: Array,
      concept: Array,
      resellerNo: Array,
      subReseller: Array,
      format: Array,
      provinceNo: Array,
      regionNo: Array,
      tzGroup: Array,
      isHubDoor: Boolean,
    }
  },
  mounted () {
    // this.getDoorList()
  },
  data: function () {
    return {
      loading: false,
      doorList: [], // 供筛选的门店列表
      searchKey: '', // 门店搜索关键字
      checkList: [], // 选中的门店
      doorDialogVisible: false,
      posId: '',
    }
  },
  /* watch: {
    value: function (val, oldVal) {
      this.checkList = val
    }
  }, */
  methods: {
    change: function () {
      console.log('同步更新')
      this.$emit('input', this.posId)
    },
    openDialog: function () {
      this.doorList = [];
      this.checkList = [];
      this.searchKey = ""
      this.doorDialogVisible = true
    },
    isEmpty: function (data) {
      return !_.isNil(data)
    },
    formatArrayToString: function (data) {
      return _.mapValues(data, function (o) {
        if (_.isArray(o)) {
          return _.join(o, ',')
        } else {
          return o
        }
      })
    },
    getDoorList: async function () {
      let filterParams = this.filterForm?
        {
        'doorName': this.searchKey,
        'cityNo': this.filterForm.city,
        'clusterGroup': this.filterForm.cityTier,
        'clusterName': this.filterForm.clusterName,
        'concept': this.filterForm.concept,
        'resellerNo': this.filterForm.reseller,
        'subReseller': this.filterForm.subReseller,
        'format': this.filterForm.format,
        'provinceNo': this.filterForm.province,
        'regionNo': this.filterForm.region,
        'tzGroup': this.filterForm.tzGroup,
        'hub': this.filterForm.hub,
        'size': 1000
      }:{'doorName':this.searchKey,'size': 1000}
      // if (clear) {
      //   submitParams = {}
      // }
      this.loading = true
      this.checkList = []
      let res = await axios.post(oprReqUrl+'door/query', filterParams)
      res = res.data
      if (res.code === 200) {
        this.doorList = res.data
      } else {
      }
      this.loading = false
    },
    submitDoor: function () {
      this.doorDialogVisible = false
      console.log('this.posId', this.posId)
      const posidList = this.posId ? this.posId.split(',') : []
      this.posId = _.uniq(posidList.concat(this.checkList)).join(',')
      this.change()
    }
  }
}
</script>

<style scoped lang="sass">
.doorList
  height: 360px
  overflow: auto
.checkboxList
  .el-checkbox
    display: block
    margin: 14px 0
    font-weight: 300
  em
    font-style: normal
</style>



// WEBPACK FOOTER //
// src/opr/components/pickDoor.vue